<template>
  <div style="width:100%; display: inherit;">
    <div class="col-md-4">
      <div class="form-group">
        <label>{{schema[0].label}}<span class="required">*</span>
        </label>
        <select class="form-control" :name="schema[0].name" v-model="parentSelected" v-validate="'required'">
          <option value="">Select</option>
          <option v-for="option in schema[0].cascadeoptions" :key="option.key" :value="option.key">
            {{option.value}}
          </option>
        </select>
        <div v-show="errors.has(schema[0].name)" class="help is-danger">{{schema[0].required_message}}</div>
      </div>
    </div>
    <div class="col-md-4" v-if="schema[1]">
      <div class="form-group">
        <label>{{schema[1].label}}<span class="required">*</span>
        </label>
        <select class="form-control" :name="schema[1].name" v-model="value[schema[1].name]" v-validate="'required'">
          <option value="">Select</option>
          <option v-for="option in childCollection" :key="option.key" :value="option.key">
            {{option.value}}
          </option>
        </select>
        <div v-show="errors.has(schema[1].name)" class="help is-danger">{{schema[1].required_message}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CASCADE',
    inject: ['$validator'],
    props: ['schema', 'value'],
    data() {
      return {
        childCollection: [],
        parentSelected: '',
        initialCreated: false
      }
    },
    created() {
      this.parentSelected = this.value[this.schema[0].name];
      this.initialCreated = true;
    },
    watch: {
      "parentSelected": function (newPP, oldPP) {
        if (this.schema[1]) {
          if (newPP) {
            if(!this.initialCreated)
            this.value[this.schema[1].name] = '';

            this.childCollection = this.schema[0].cascadeoptions.filter((s) => {
              return s.key == newPP;
            })[0].options;

          } else {
            this.childCollection = [];
            this.value[this.schema[1].name] = '';
          }
        }

        this.value[this.schema[0].name] = newPP;
        this.initialCreated = false;
      },

    }
  }

</script>